import { useState, useEffect, useCallback } from 'react';
import { recoveryApi, ApiError } from '../services/recoveryApi';
import type { LegalCaseDetail } from '../types/LegalCase';

// Carrega o detalhe de um caso (page-view) para a página dedicada com navegação por seção.
// Substitui o painel lateral da listagem: o clique na linha navega para /recovery/legal-cases/:id.
export default function useLegalCaseDetail(caseId: string | undefined) {
    const [detail, setDetail] = useState<LegalCaseDetail | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);

    const fetchDetail = useCallback(async () => {
        // Sem id (rota malformada / param ausente): não há caso a carregar. Sai do loading e
        // marca não-encontrado, senão o hook ficaria preso em isLoading=true para sempre.
        if (!caseId) {
            setDetail(null);
            setNotFound(true);
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        setNotFound(false);
        try {
            const result = await recoveryApi.getLegalCaseView(caseId);
            setDetail(result);
        } catch (e: any) {
            if (e instanceof ApiError && e.status === 404) {
                setNotFound(true);
            }
            setDetail(null);
        } finally {
            setIsLoading(false);
        }
    }, [caseId]);

    useEffect(() => { fetchDetail(); }, [fetchDetail]);

    return { detail, isLoading, notFound, refresh: fetchDetail };
}
